import React from 'react'
import { SIZES } from 'src/styles/theme'
import styled from 'styled-components'

const TermsWrapper = styled.div`
  padding: 12px;
  color: #022136;
  font-size: 90%;
  max-height: 350px;
  overflow-y: scroll;
  h6 {
    color: #F85D49;
    font-weight: 600;
  }
  h6, p {
    width: 90%;
    margin: 10px auto;
  }
  p {
    display: flex;
    span {
      margin-left: 8px;
    }
  }
  ul {
    width: 85%;
    margin: 10px auto;
    list-style-type: lower-alpha;
  }
  ${SIZES.mobile} {
    min-height: 350px;
    max-height: inherit;
    ul, p {
      font-size: 80%;
      span {
        margin-left: 6px;
      }
    }
  }
`

function TermsTab() {
  return (
    <TermsWrapper>
      <h6>Terms and Conditions</h6>
      <p>1.<span>Participants must earn 80 points on the first and another 80 points on the second day of CEO Day event to participate in the lucky draw. Points are earned through completing missions at the booths in the exhibition hall.</span></p>
      <p>2.<span>There will be different tasks at each booth. Task may include watching a video, viewing a poster or reading a product information leaflet. Each mission is worth ten points.</span></p>
      <p>3.<span>Winners will be announced on Monday 25<sup>th</sup> October at 10am.</span></p>
      <p>4.<span>Points system:</span></p>
      <ul>
        <li>Ten points can be earned from each booth on each day. A coin icon will appear once the task has been completed.</li>
        <li>Participants who accumulate 160 points by the end of CEO Day (24<sup>th</sup> October 2021 at 5pm) will qualify for the lucky draw.</li>
        <li>The draw will randomly select 50 participants with 160 points accumulated. Winners will win the KFC voucher worth RM50.</li>
      </ul>
    </TermsWrapper>
  )
}

export { TermsTab }